import type { ApiResponse } from "@/types/apiResponse";
import type { UserType } from "../types/user";
import type { AuthError } from "../../auth/types/auth";

const typesUsers = async (): Promise<ApiResponse<UserType[]>> => {
  try {
    const response = await fetch(`${API_HOST}/v1/usuario/tipos`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  } catch {
    throw { message: "Error al iniciar sesión" } as AuthError;
  }
};

export default typesUsers;
